enum HeadingTypeEnum {
  h1_Large = "h1_Large",
  h1_Small = "h1_Small",
  h2_Large = "h2_Large",
  h2_Small = "h2_Small",
  h3_Default = "h3_Default",
  h3_Small = "h3_Small",
  h4_Default = "h4_Default",
}
export default HeadingTypeEnum;
